module.exports = __webpack_public_path__ + "static/media/CLP.4a7647c5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/App/components/CoinCircle/icons/CLP.svg
// module id = 1497
// module chunks = 85